import { SOCIAL_AD_TYPES } from "utils/constants";

import FacebookImage from "social/formats/FacebookImage";
import FacebookVideo from "social/formats/FacebookVideo";
import FacebookCarousel from "social/formats/FacebookCarousel";

import GoogleDemandGenImage from "widgets/social2/formats/GoogleDemandGenImage";

import FacebookImageMO from "social/formats/FacebookImageMO";
import FacebookVideoMO from "social/formats/FacebookVideoMO";
import FacebookCarouselMO from "social/formats/FacebookCarouselMO";

import GoogleDemandGenCarousel from "widgets/social2/formats/GoogleDemandGenCarousel";

import LinkedInImage from "social/formats/LinkedInImage";
import LinkedInVideo from "social/formats/LinkedInVideo";
import LinkedInCarousel from "widgets/social2/formats/LinkedInCarousel";

import PinterestImage from "social/formats/PinterestImage";
import PinterestVideo from "social/formats/PinterestVideo";
import PinterestMaxWidthVideo from "social/formats/PinterestMaxWidthVideo";
import PinterestCarousel from "social/formats/PinterestCarousel";

import SnapchatImage from "social/formats/SnapchatImage";
import SnapchatVideo from "social/formats/SnapchatVideo";

import TwitterImage from "social/formats/TwitterImage";
import TwitterVideo from "social/formats/TwitterVideo";

import YouTubeInStream from "social/formats/YouTubeInStream";
import YouTubeDiscovery from "social/formats/YouTubeDiscovery";

import TikTokVideo from "widgets/social2/formats/TikTokVideo";

export const FORM_BY_ADTYPE = {
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE]: FacebookImage,
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO]: FacebookVideo,
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL]: FacebookCarousel,
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO]: FacebookImageMO,
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO]: FacebookVideoMO,
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO]: FacebookCarouselMO,

	[SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_IMAGE]: GoogleDemandGenImage,
	[SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_CAROUSEL]: GoogleDemandGenCarousel,

	[SOCIAL_AD_TYPES.LINKEDIN_IMAGE]: LinkedInImage,
	[SOCIAL_AD_TYPES.LINKEDIN_VIDEO]: LinkedInVideo,
	[SOCIAL_AD_TYPES.LINKEDIN_CAROUSEL]: LinkedInCarousel,

	[SOCIAL_AD_TYPES.PINTEREST_IMAGE]: PinterestImage,
	[SOCIAL_AD_TYPES.PINTEREST_VIDEO]: PinterestVideo,
	[SOCIAL_AD_TYPES.PINTEREST_MAX_WIDTH_VIDEO]: PinterestMaxWidthVideo,
	[SOCIAL_AD_TYPES.PINTEREST_CAROUSEL]: PinterestCarousel,

	[SOCIAL_AD_TYPES.SNAPCHAT_IMAGE]: SnapchatImage,
	[SOCIAL_AD_TYPES.SNAPCHAT_VIDEO]: SnapchatVideo,

	[SOCIAL_AD_TYPES.TWITTER_IMAGE]: TwitterImage,
	[SOCIAL_AD_TYPES.TWITTER_VIDEO]: TwitterVideo,

	[SOCIAL_AD_TYPES.YOUTUBE_INSTREAM]: YouTubeInStream,
	[SOCIAL_AD_TYPES.YOUTUBE_DISCOVERY]: YouTubeDiscovery,

	[SOCIAL_AD_TYPES.TIKTOK_VIDEO]: TikTokVideo,
};
